export default "__VITE_ASSET__BDfvf802__"